import { useState } from 'react';
import type { WeaponKind } from '../data/mockLots';
import { SkinFrame } from './SkinFrame';

type Palette = { from: string; via: string; to: string; accent: string };

type Props = {
  imageUrl: string;
  alt: string;
  weapon: WeaponKind;
  palette: Palette;
  rarityColor?: string | null;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
};

function rarityPalette(rarityColor: string, fallback: Palette): Palette {
  return {
    from: fallback.from,
    via: rarityColor,
    to: rarityColor,
    accent: rarityColor,
  };
}

export function SkinThumbnail({
  imageUrl,
  alt,
  weapon,
  palette,
  rarityColor,
  size = 'md',
  className,
}: Props) {
  const [errored, setErrored] = useState(false);
  const effectivePalette = rarityColor ? rarityPalette(rarityColor, palette) : palette;

  if (errored) {
    return (
      <SkinFrame weapon={weapon} palette={effectivePalette} size={size} className={className} />
    );
  }

  return (
    <div className={`relative w-full h-full ${className ?? ''}`}>
      <div className="absolute inset-0">
        <SkinFrame weapon={weapon} palette={effectivePalette} size={size} showWeapon={false} />
      </div>
      <img
        src={imageUrl}
        alt={alt}
        loading="lazy"
        decoding="async"
        onError={() => setErrored(true)}
        className="relative w-full h-full object-contain z-[1]"
        style={{
          filter: 'drop-shadow(0 8px 24px rgba(0,0,0,0.55))',
        }}
      />
    </div>
  );
}
